import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SapCommunicationLogEntry } from './sap-communication.model';
import { SapCommunicationLogService } from './sap-communication-log.service';

export class SapCommunicationDataSource implements DataSource<SapCommunicationLogEntry> {

  private dataSubject = new BehaviorSubject<SapCommunicationLogEntry[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private accountService: SapCommunicationLogService) {}

  connect(collectionViewer: CollectionViewer): Observable<SapCommunicationLogEntry[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadLog(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'createdOn',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.accountService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.order_history_sap);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
